import { FunctionComponent } from 'react';

import {
  Bar,
  Brush,
  CartesianGrid,
  ComposedChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  LabelList
} from 'recharts';

import { TRefundRateReportData } from 'src/types/Reports/refundRate.model';
import { convertNumberToString } from 'src/utils/commons/number';

type RefundRateProps = {
  data: TRefundRateReportData;
};

const CustomizedAxisTick: FunctionComponent<any> = (props: any) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-25)">
        {payload.value}
      </text>
    </g>
  );
};

const renderCustomizedLabel = (props: any) => {
  const { x, y, width, value } = props;
  const radius = 10;

  return (
    <g>
      <text x={x + width / 2} y={y - radius} fill="#8884d8" textAnchor="middle" dominantBaseline="middle">
        {`${value}%`}
      </text>
    </g>
  );
};

const getIntroOfPage = (label: string) => {
  if (label === 'Refund PC' || label === 'Refund PS') {
    return 'đơn';
  }
  if (label === 'Refund Expected') {
    return 'đ';
  }
  return '';
};

export default function RefundRateColumnChart({ data }: RefundRateProps) {
  return (
    <>
      <ResponsiveContainer width="100%" aspect={2}>
        <ComposedChart
          width={500}
          height={400}
          data={data.refundRateReportDatas}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5
          }}
        >
          <YAxis orientation="left" yAxisId="left" />
          <YAxis orientation="right" yAxisId="right" tickFormatter={value => `${convertNumberToString(value)}`} />
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey={data.refundRateReportDatas.length < 10 ? 'name' : 'index'}
            height={80}
            className="pb-8"
            tick={<CustomizedAxisTick />}
          />
          <Tooltip
            labelFormatter={(label: string, props: any) => {
              if (props.length > 0 && props[0].payload) {
                return props[0].payload.name;
              }
              return '';
            }}
            formatter={(value: number, name: string) => `${convertNumberToString(value)} ${getIntroOfPage(name)}`}
          />
          <Legend />
          <Bar dataKey="refundPC" name="Refund PC" stackId="a" isAnimationActive={true} yAxisId="left" fill="#8884d8" />
          <Bar dataKey="refundPS" name="Refund PS" stackId="a" isAnimationActive={true} yAxisId="left" fill="#82ca9d">
            <LabelList dataKey="refundActual" content={renderCustomizedLabel} />
          </Bar>
          <Bar
            dataKey="refundExpect"
            name="Refund Expected"
            stackId="b"
            isAnimationActive={true}
            yAxisId="right"
            fill="#03c2fc"
          />
          <Brush dataKey="name" height={30} stroke="#fca903" />
        </ComposedChart>
      </ResponsiveContainer>
    </>
  );
}
